
import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserModule } from '../../store/modules/user';
import DialogSetStaff from '../staff/components/setStaff.vue';
import DialogSelectCustomer from '@/components/CustomerDialog/levelByLevel.vue';
import { getStockInoutTypeList, stockOut } from '@/api/stock';
import { checkPermissionCompany } from "@/utils/permission";
import { Type } from "@/types/permissionType";

@Component({
  name: 'StockInout',
  components: {
    DialogSetStaff,
    DialogSelectCustomer
  }
})
export default class extends Vue {
  private formContent: any = {
    type: {},
    staff: '',
    outstaff: '',
    returnParts: '',
    returnOrder: '',
    outnumber: '',
    customer: '',
    remark: ''
  }
  private typeOptions = []
  private dialogSelectStaffVisible = false
  private radioSelectedStaff = true
  private customerVisible = false
  private customerSelectDialogVisible = false
  private modelId:any = ''
  private stockName:any = '';
  private model : any = ''

  private rules = {
    type: [{ required: true, message: '请填选择出库类型', trigger: 'blur' }],
    outstaff: [{ required: true, message: '请填选择出库人员'}],
    outnumber: [
      { required: true, message: '请填写出库数量', trigger: 'blur' },
      {  validator: this.validateDecimal, trigger: 'change' }
    ]
  }
  private validateDecimal(rule: any, value: any, callback: any) {
    //小数最多两位
    if (!/^[0-9]+(\.[0-9]{0,2})?$/.test(value)) {
      callback(new Error('请输入正确的数字格式(最多两位小数)'));
    } else {
      callback();
    }
  }
  created() {
    this.model = JSON.parse(this.$route.query.model as string);
    this.modelId = this.$route.query.model_id;
    this.stockName = this.$route.query.stock_name;
    this.getStockInoutTypeList();
    this.formContent.staff = UserModule.getUserName;
    this.customerVisible = checkPermissionCompany(
          UserModule.getCompanyId,
          Type.CUSTOMER_COMPANY
        )
  }
  // 获取 入库类型
  private getStockInoutTypeList() {
    let params: any = {};
    params.user_id = UserModule.getUserId;
    params.user_name = UserModule.getUserName;
    params.company_id = UserModule.getCompanyId;
    params.company_name = UserModule.getCompanyName;
    params.is_out_check = '0';
    params.type = '2';
    getStockInoutTypeList(params)
      .then((res) => {
        if (res.data) {
          this.typeOptions = res.data.list;
        }
      })
      .catch((error) => {
        let msg = error.msg;
      });
  }

  // 点击入库人员 弹出人员弹窗
  private selectStaffHandle() {
    this.dialogSelectStaffVisible = true;
  }

  // 关闭人员弹窗
  private closeStaffHandle(val: any) {
    this.dialogSelectStaffVisible = val;
  }

  // 人员选择确定
  private selectedStaffHandle(val:any) {
    this.formContent.outstaff = val;
  }

  // 关闭客户选择弹窗
  private closeCustomer() {
    this.customerSelectDialogVisible = false;
  }

  // 选择客户
  private selectCustomerHandle(val:any) {
    this.formContent.customer = val;
  }

  private stockOut() {
    (this.$refs.ruleForm as any).validate((valid: any) => {
      if (valid) {
        this.stockOutNet();
      } else {
        return false;
      }
    });
  }

  private stockOutNet() {
    let params: any = {};
    params.user_id = UserModule.getUserId;
    params.user_name = UserModule.getUserName;
    params.company_id = UserModule.getCompanyId;
    params.company_name = UserModule.getCompanyName;
    params.model_id = this.modelId;
    params.stock_name = this.stockName;
    params.inout_type = this.formContent.type.id;
    params.inout_type_name = this.formContent.type.name;
    params.remark = this.formContent.remark;
    params.inout_user_id = this.formContent.outstaff.id;
    params.inout_user_name = this.formContent.outstaff.name;
    params.operate_user_id = UserModule.getUserId;
    params.operate_user_name = UserModule.getUserName;
    params.num = this.formContent.outnumber;
    if (this.formContent.customer) {
      if (parseInt(this.formContent.customer.customer_type) === 1) {
        params.customer_company_id = this.formContent.customer.customer_company_id;
        params.customer_company_name = this.formContent.customer.name;
        params.customer_name = this.formContent.customer.name;
      } else {
        params.customer_user_id = this.formContent.customer.customer_user_id;
        params.customer_user_name = this.formContent.customer.name;
        params.customer_name = this.formContent.customer.name;
      }
    }
    stockOut(params)
      .then((res:any) => {
        if (res.data) {
          this.showSuccessMsg(res.msg);
          this.$router.go(-1);
        }
      })
      .catch((error) => {
        let msg = error.msg;
        this.showErrorMsg(msg);
      });
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }

  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: window.innerHeight * 0.4,
      customClass: 'notification-center',
      type: 'success'
    });
  }
}
